export default __webpack_public_path__ + "static/media/SCCS.b7babc6e.pdf";